{
	"title": "Algo de errado aconteceu",
	"subtitle": "Código do erro",
	"description": "A nossa equipe já foi notificada do erro. Por favor, recarregue a página e tente novamente.",
	"descriptionWithError": "Caso o problema seja recorrente, informe a nossa equipe o código acima."
}
